export function isNumeric (x) {
  return !isNaN(parseFloat(x)) && isFinite(x)
}
export function isHex(x) {
  const regx = /[0-9A-Fa-f]/;
  return regx.test(x)
}
export function isDeviceId (x) {
  const regx = /^[0-9A-Fa-f]{8}$/;
  return regx.test(x)
}
